import React, { PropTypes, Component } from 'react';
import Icon from '../../tc-ui/icon';
import { beddingConfigOptions } from '../../../utils/select-fields';
import BeddingConfigDumb from './bedding-configuration-dumb';
import { removeAtIndex, notEqual, neither } from '../../../utils/functional';
import { compose, pathOr, ifElse, always, prop, identity, isNil, has, any, flatten, call, both } from 'ramda';

class BeddingConfig extends Component {

  componentWillReceiveProps(nextProps) {
    if (notEqual(this.props.routeName, nextProps.routeName)) this.setState({ showResults: false });
  }

  getListElementStyle(width, height, otherCss) {
    return Object.assign({
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: '400',
      color: 'rgb(54%, 54%, 54%)',
      lineHeight: '21px',
      overflow: 'auto',
      clear: 'both',
      paddingRight: '16px',
      height: height || 'auto',
      verticalAlign: 'top',
      width,
    }, otherCss || {});
  }

  getHeaderStyle(width) {
    return {
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: '600',
      color: 'rgb(54%, 54%, 54%)',
      marginRight: '16px',
      width,
    };
  }

  _editBeddingConfig = (index) => {
    const { editField } = this.props;
    const options = beddingConfigOptions;
    editField('bedsAndSofas', {
      type: 'bedsAndSofas',
      isRequired: true,
      index,
      options,
    });
  };

  _removeBeddingConfig = (index) => {
    const updateBeddingConfigs = compose(
      this.props._saveField,
      updateBody => ({ updateField: 'bedsAndSofas', updateBody }),
      removeAtIndex(index),
      pathOr([], ['profileToShow', 'bedsAndSofas']));
    updateBeddingConfigs(this.props);
  };

  _addBeddingConfig = () => {
    const options = beddingConfigOptions;
    this.props.editField('bedsAndSofas',
      { type: 'bedsAndSofas',
        initialValue: this.props.profileToShow.bedsAndSofas,
        index: this.props.profileToShow.bedsAndSofas.length,
        options,
      });
  };

  render() {
    const { isEditable } = this.props;
    const title = 'Bedding Configuration';
    const bedsAndSofas = pathOr([], ['profileToShow', 'bedsAndSofas'], this.props);
    const hasContent = call(compose(
      ifElse(
        isNil,
          always(false),
        compose(
          any(has('bedType')),
          flatten
        )
      ),
      prop('rooms')
    ), bedsAndSofas);

    const addBeddingConfiguration = ifElse(
      both(identity, () => !hasContent),
        () => (
          <div onClick={this._addBeddingConfig} className="description-segments-add" style={{ marginBottom: '32px' }}>
            <Icon className="tc-icon-add description-segments-add-icon"/>
            <span className="description-segments-add-label">Add Bedding Configuration</span>
          </div>
        ),
      always(undefined)
    );


    const header = (
      <div style={{ lineHeight: '48px', textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.87)' }}>
        {title}
        <span onClick={this._addBeddingConfig} className="description-segments-edit" style={{ marginLeft: '6px', display: isEditable && hasContent ? 'inline-block' : 'none' }}>
          <Icon style={{ fontSize: '14px', marginRight: '4px' }} className="tc-icon-mode_edit"/>
          Edit
        </span>
      </div>
    );

    if (neither(hasContent, isEditable)) return false;
    return (
      <div style={{ marginTop: '32px' }} id="beddingConfig">
        {header}
        <div className="l-paper-split-segment">
          <BeddingConfigDumb bedsAndSofas={bedsAndSofas} />
        </div>
        {addBeddingConfiguration(isEditable)}
      </div>
    );
  }
}

BeddingConfig.propTypes = {
  isEditable: PropTypes.bool,
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
  routeName: PropTypes.string,
  _saveField: PropTypes.func,
};

module.exports = BeddingConfig;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/bedding-config.jsx